module.exports = __webpack_public_path__ + "media/images/teams/logo__11-564a4ddf186c2a03885c42c217f751d6.svg";